// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","productCard":"products-card_productCard__pwKvS","opened":"products-card_opened__OPerz","showDetails":"products-card_showDetails__Y3lkm"};